import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { collection, addDoc } from "firebase/firestore";
import "./GpconRegForm.css";
import QrCode from "../../assets/qr-img.jpg";
import Footer from "../../components/Footer/Footer";
import { storage } from "../../firebase"; // Import Firebase Storage
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Storage functions
import { MdSaveAlt } from "react-icons/md";
const GpconRegForm = () => {
  useEffect(() => {
    import("bootstrap/dist/css/bootstrap.min.css");
  }, []);

  const generateRegistrationID = (role) => {
    const randomNum = Math.floor(10000 + Math.random() * 90000); // Generates a 5-digit number
    let prefix = "GEN"; // Default prefix

    switch (role) {
      case "student":
        prefix = "STU";
        break;
      case "deligate":
        prefix = "DEL";
        break;
      case "spot registration":
        prefix = "SPT";
        break;
      default:
        prefix = "GEN";
    }

    return `${prefix}-${randomNum}`;
  };
  const [formData, setFormData] = useState({
    role: "student",
    name: "",
    mobile: "",
    email: "",
    address: "",
    city: "",
    pincode: "",
    paymentScreenshot: null,
    bankName: "",
    transactionDate: "",
    collegeName: "",
    bonafideOrMarksheet: "",
    studyYear: "",
    registrationID: generateRegistrationID("student"),
    registrationSubmittedTime: null,
  });
  const [loading, setLoading] = useState(false);

  const [showPayment, setShowPayment] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      registrationID: generateRegistrationID(prev.role),
    }));
  }, [formData.role]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.role === "deligate") {
      alert("Delegate registrations are closed. Please select another option.");
      return;
    }
    else{
    setFormData((prevData) => ({
      ...prevData,
      transactionId: "", // Reset only payment fields
      bankName: "",
      transactionDate: "",
    }));

    setShowPayment(true);}
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    if (!formData.paymentScreenshot) {
      alert("Please upload both payment screenshot ");
      return;
    }

    setLoading(true);
    try {
      // Upload Payment Screenshot
      const paymentRef = ref(
        storage,
        `paymentScreenshots/${formData.paymentScreenshot.name}`
      );
      const paymentSnapshot = await uploadBytes(
        paymentRef,
        formData.paymentScreenshot
      );
      const paymentURL = await getDownloadURL(paymentSnapshot.ref);

      // Upload Bonafide/Marksheet
      const bonafideRef = ref(
        storage,
        `bonafideOrMarksheet/${formData.bonafideOrMarksheet.name}`
      );
      const bonafideSnapshot = await uploadBytes(
        bonafideRef,
        formData.bonafideOrMarksheet
      );
      const bonafideURL = await getDownloadURL(bonafideSnapshot.ref);

      // Save form data to Firestore
      await addDoc(collection(db, "GPCON-registrations"), {
        ...formData,
        registrationSubmittedTime: new Date().toISOString(),
        paymentScreenshot: paymentURL, // Store the URL, not the file itself
        bonafideOrMarksheet: bonafideURL,
      });

      sendEmail(formData);

      navigate("/registration-success", { state: formData });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Something went wrong! Please try again.");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 5000);
    }
  };

  const sendEmail = async (formData) => {
    // Check if the email, username, and password are present in formData
    if (!formData.email || !formData.name || !formData.role) {
      console.error("Missing required fields: email, username, or password");

      return null;
    }

    // Validate the email format using a regular expression
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      console.error("Invalid email format");

      return null;
    }

    const subject = "🎉 Welcome to GPCON 2025! Your Registration is Confirmed";
    const text = `

Dear ${formData.name},

Congratulations! 🎊 Your registration for GPCON 2025 has been successfully completed. We're thrilled to have you on board!

📅 Event Date: 2nd March 2025
📍 Venue: Shrimant Narayanrao Babasaheb Ghorpade Natyagruha MFJ9+2GV, Rajwada, Ichalkaranji, Maharashtra 416115
🎟 Your Registration ID: ${formData.registrationID}

Get ready for an exciting experience filled with knowledge, networking, and new opportunities! 🚀

What’s Next?

🗺️ Plan Your Visit – Check the venue location and arrange your travel in advance.

📜 Event Schedule Incoming – Keep an eye on your email for the agenda and speaker lineup.

🎟️ Bring Your Confirmation – Show your registration ID at the entrance for a smooth check-in.

🎁 Special Surprises Await! – Be ready for an interactive experience with exciting takeaways.

If you have any questions, feel free to contact us at gpaichalkarnji@gmail.com.

We can't wait to see you there! 🤩

Best Regards,
General Practitioner's Association of Ichalkaranji
gpaichalkaranji.com/gpcon2025
`;

    try {
      const response = await fetch(
        "https://gpa-backend-1x73.onrender.com/api/send-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            recipientEmail: formData.email, // Ensure this is being passed correctly
            subject,
            text,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      const data = await response.json();
      console.log("Email sent successfully", data);
      setLoading(false);
      return data;
    } catch (error) {
      console.error("Error sending email:", error);

      return null;
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  const generateUpiLink = () => {
    const upiID = "9850112972m@pnb";
    const amount =
      formData.role === "student"
        ? "500"
        : formData.role === "deligate"
        ? "600"
        : "700";
    const name = encodeURIComponent(formData.name || "GPCON Participant");
    const transactionNote = "GPCON 2025 Registration";

    return `upi://pay?pa=${upiID}&pn=${name}&mc=0000&tid=${Date.now()}&tr=${Date.now()}&tn=${transactionNote}&am=${amount}&cu=INR`;
  };

  return (
    <>
      <div className="gpcon-registration-fullcontainer">
        <div className=" gpcon-registration-formcontainer shadow-sm p-4 my-4  rounded">
          {!showPayment ? (
            <form className="gpcon-registration-form" onSubmit={handleSubmit}>
              <div className="gpcon-registration-form-group">
                <h2 className="text-center mb-4">REGISTER FOR GPCON 2025 </h2>

                <div class="line-divider"></div>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Select Your Registration Type:
                </label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="form-select form-control"
                  required
                  
                >
                  <option value="" disabled selected>
                    {" "}
                    -- Select Registration Type --{" "}
                  </option>
                  <option value="deligate">Deligate</option>
                  <option value="student">Student</option>
                  <option value="spot registration">Spot registration</option>
                </select>
              </div>

              {formData.role === "deligate" && (
                <p className="text-danger">Delegate registrations are closed</p>
              )}

              {formData.role === "student" && (
                <>
                  <div className="mb-3">
                    <input
                      type="text"
                      name="collegeName"
                      value={formData.collegeName || ""}
                      placeholder="Name of College"
                      required={formData.role === "student"}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="text"
                      name="studyYear"
                      value={formData.studyYear || ""}
                      placeholder="Studying Year"
                      required={formData.role === "student"}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Upload Bonafide Certificate or Last Year Marksheet
                    </label>
                    <input
                      type="file"
                      name="bonafideOrMarksheet"
                      accept=".jpg, .jpeg, .png, .pdf, .docx"
                      required={formData.role === "student"}
                      onChange={handleFileChange}
                      className="form-control"
                    />
                  </div>
                </>
              )}

              <div className="mb-3">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  placeholder="Full Name"
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="mb-3">
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  placeholder="Mobile Number"
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  placeholder="Email"
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={formData.address}
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    placeholder="City"
                    required
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    name="pincode"
                    placeholder="Pincode"
                    value={formData.pincode}
                    required
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Proceed to Payment
              </button>
            </form>
          ) : (
            <form className="gpcon-payment-form" onSubmit={handlePaymentSubmit}>
              <h2 className="text-center mb-4">Complete Your Payment</h2>
              <p className="fee-amount text-center mb-3">
                Fees: ₹
                {formData.role === "student"
                  ? "500"
                  : formData.role === "deligate"
                  ? "600"
                  : formData.role === "spot registration"
                  ? "700"
                  : ""}
              </p>

              <div className="text-center mb-4">
                <p>
                  Scan the QR code to make the payment (Save the QR code and
                  make the payment using UPI apps)
                </p>
                <img
                  src={QrCode}
                  alt="QR Code for Payment"
                  className="qr-image img-fluid"
                  style={{ maxWidth: "200px", cursor: "pointer" }}
                />
                <div className="mt-2">
                  <a
                    href={QrCode}
                    download="GPAI_QR_Code.png"
                    className="btn btn-primary "
                    style={{
                      backgroundColor: "#15AB98",
                      borderColor: "#15AB98",
                      cursor: "pointer",
                    }}
                  >
                    <MdSaveAlt /> Save
                  </a>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Upload Payment Screenshot/Receipt
                </label>
                <input
                  type="file"
                  name="paymentScreenshot"
                  accept="image/*"
                  required
                  onChange={handleFileChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  name="bankName"
                  placeholder="Enter Your Bank Name"
                  value={formData.bankName}
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <input
                  type="date"
                  name="transactionDate"
                  value={formData.transactionDate}
                  required
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <button
                type="submit"
                className="btn btn-success w-100"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Processing...
                  </>
                ) : (
                  "Submit Registration"
                )}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GpconRegForm;
